export class Recuperar {

    de: string;
    para: string;
    token: string;

    constructor() {

        this.de = "";
        this.para = "";
        this.token = "";

    }

    

}

export class Reestablecer {

    id: string;
    clave: string;
    
    constructor() {

        this.id = "";
        this.clave = "";
       
    }
}